import type { Film } from "@/types/film";

export const films: Film[] = [
  {
    id: "second-farewell",
    title: "母亲的第二次告别",
    originalTitle: "The Second Farewell",
    kind: "movie",
    year: 2024,
    region: "中国大陆",
    genres: ["家庭", "剧情", "伦理"],
    rating: 8.9,
    votes: 48210,
    views: 326000,
    director: "苏怀瑾",
    cast: ["周蔓", "林砚", "许清和", "白蕊"],
    duration: "128 分钟",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20poster%20art%20of%20an%20elderly%20mother%20and%20her%20adult%20daughter%20sitting%20side%20by%20side%20on%20a%20hospital%20bed%20by%20a%20large%20window%2C%20soft%20white%20linen%20and%20navy%20shadows%20with%20warm%20amber%20afternoon%20light%2C%20tender%20restrained%20mood%2C%20film%20grain%2C%20minimal%20editorial%20photography%2C%20no%20text&width=600&height=800&seq=cover-second-farewell&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20wide%20shot%20of%20a%20quiet%20sunlit%20hospital%20room%20with%20white%20curtains%20and%20a%20single%20bedside%20chair%2C%20warm%20amber%20afternoon%20light%20falling%20across%20the%20floor%2C%20deep%20navy%20shadows%20in%20the%20corners%2C%20soft%20film%20grain%2C%20melancholic%20atmospheric%20still%2C%20no%20text&width=1600&height=900&seq=backdrop-second-farewell&orientation=landscape",
    tagline: "有些告别，是爱的第二次开始",
    summary:
      "一位母亲在确诊阿尔茨海默症后，开始一点点忘记自己的女儿。女儿辞去工作回到老宅，在重复的日常里重新认识这个曾经强势的女人。",
    synopsis: [
      "林知微在四十岁那年接到医院的电话：母亲被确诊为阿尔茨海默症早期。她回到阔别多年的江南老宅，发现母亲已经把家里的钟全部调快了一小时，理由是「这样时间就不会不够用」。",
      "随着记忆的退潮，母女之间被刻意掩盖的旧事一件件浮出水面：父亲去世那年母亲的决定、被放弃的留学机会、以及那句从未说出口的「我其实很怕你」。知微开始用录音笔记录母亲每天说的话，她发现母亲在忘记她的同时，也终于开始说真话。",
      "影片不回避照护的现实重量。护工、床位、兄弟姐妹之间的费用分摊，构成了一张细密的现实之网。在第三次告别到来时，母女二人终于完成了一次真正平等的对话。",
    ],
    roles: [
      {
        name: "林知微",
        actor: "周蔓",
        description:
          "四十二岁的纪录片剪辑师，习惯用镜头观察别人，却始终不敢看自己的母亲。她的克制是长年训练的产物，也是自我保护的方式。",
      },
      {
        name: "母亲 · 沈玉琴",
        actor: "白蕊",
        description:
          "退休中学语文教师，一生要强。疾病把她的控制欲一点点剥离，留下的却是一个意外温柔、会向女儿道歉的女人。",
      },
      {
        name: "弟弟 林知远",
        actor: "林砚",
        description:
          "在深圳经营小公司的次子，主张把母亲送进专业机构。他不是不孝，只是先一步承认了自己的无力。",
      },
    ],
    reviews: [
      {
        title: "当记忆开始背叛爱",
        author: "沈砚秋",
        date: "2024-11-08",
        excerpt:
          "阿尔茨海默症不是这部电影真正的主题，真正被追问的是：当一个人不再记得你，你们之间的责任还成立吗？",
        content: [
          "影片拒绝把遗忘拍成一种煽情。镜头始终保持着近乎冷静的距离：母亲把女儿认成自己的妹妹，女儿没有反驳，只是顺着话题继续往下说。",
          "三次告别层层递进，把亲情从血缘的理所当然，还原成一次次重新选择的结果。",
        ],
      },
      {
        title: "厨房里的伦理课",
        author: "陆时安",
        date: "2024-10-22",
        excerpt:
          "所有关于「谁来照顾母亲」的争吵都发生在厨房，背景是还没洗完的碗。这种琐碎的现场感，让道德判断变得迟疑。",
        content: [
          "导演刻意不给任何一方道德优势。长女的牺牲与次子的现实，都在镜头里获得了同等的重量。",
          "这也是本片最难得的地方：它相信观众有能力承受一个没有标准答案的结局。",
        ],
      },
    ],
    featured: true,
  },
  {
    id: "undercurrent",
    title: "暗流",
    originalTitle: "Undercurrent",
    kind: "series",
    year: 2023,
    region: "中国大陆",
    genres: ["悬疑", "伦理", "剧情"],
    rating: 8.8,
    votes: 61530,
    views: 512000,
    director: "郑北",
    cast: ["程野", "叶南", "梁书信", "顾承"],
    episodes: 12,
    duration: "单集 45 分钟",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20poster%20art%20of%20a%20lone%20reporter%20standing%20at%20the%20end%20of%20a%20flooded%20underground%20corridor%2C%20cold%20navy%20darkness%20with%20a%20single%20warm%20amber%20exit%20sign%2C%20water%20reflections%2C%20film%20grain%2C%20tense%20minimal%20composition%2C%20editorial%20photography%2C%20no%20text&width=600&height=800&seq=cover-undercurrent&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20wide%20shot%20of%20an%20empty%20city%20street%20at%20midnight%20after%20heavy%20rain%2C%20neon%20reflections%20on%20wet%20asphalt%20in%20muted%20navy%20and%20amber%2C%20a%20distant%20figure%20holding%20an%20umbrella%2C%20film%20noir%20atmosphere%2C%20soft%20grain%2C%20no%20text&width=1600&height=900&seq=backdrop-undercurrent&orientation=landscape",
    tagline: "查真相的人，也是共谋的一部分",
    summary:
      "一桩尘封十年的旧案重新浮出水面。调查记者在追查真相的过程中发现，每一个知情者的沉默都在为悲剧续命。",
    synopsis: [
      "十二集剧集以一个雨夜开场：某小区地下车库发现一具无名遗骸。调查记者沈砚接到匿名线报，发现这起案件与十年前的一桩拆迁纠纷有关。",
      "随着调查推进，她遇到的每一个人都只是「没做什么」：邻居没有报警，物业没有保存监控，同事没有作证。没有人是凶手，但所有人都参与了掩盖。",
      "剧集用大量固定镜头拍摄走廊与楼道，让人物被困在画框之内。真相最终公开，却没有人因此变得更好。",
    ],
    roles: [
      {
        name: "沈砚",
        actor: "叶南",
        description:
          "调查记者，职业伦理与私人情感长期冲突。她相信真相有净化的力量，直到亲手摧毁了一个家庭。",
      },
      {
        name: "老周",
        actor: "梁书信",
        description:
          "退休片警，当年案件的第一个知情人。他用二十年的沉默换取体面，也被这份体面囚禁了二十年。",
      },
      {
        name: "程野",
        actor: "程野",
        description:
          "拆迁公司中层，案件的执行者而非决策者。他最常说的一句话是「我也是听命行事」。",
      },
    ],
    reviews: [
      {
        title: "真相的代价由谁承担",
        author: "周慕之",
        date: "2024-08-15",
        excerpt:
          "每揭开一层，就有一个普通人被卷进去。它真正问的是：我们有权知道一切吗？",
        content: [
          "第六集里，女主角为了保护线人而放弃了足以定案的证据，这个选择既没有被赞扬，也没有被谴责。",
          "结尾克制得近乎残忍：真相公开了，但没有人因此变得更好。",
        ],
      },
    ],
    featured: true,
  },
  {
    id: "under-eaves",
    title: "屋檐之下",
    originalTitle: "Under the Eaves",
    kind: "series",
    year: 2022,
    region: "日本",
    genres: ["家庭", "伦理", "生活"],
    rating: 9.0,
    votes: 73920,
    views: 604000,
    director: "佐藤和彦",
    cast: ["小林千春", "森川启", "吉冈澄", "阿部遥"],
    episodes: 10,
    duration: "单集 50 分钟",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20poster%20art%20of%20a%20japanese%20family%20dining%20table%20in%20a%20small%20old%20house%20at%20night%20seen%20from%20above%2C%20bowls%20of%20rice%20and%20a%20low%20warm%20amber%20lamp%2C%20deep%20navy%20shadows%20around%20the%20frame%2C%20film%20grain%2C%20intimate%20quiet%20mood%2C%20editorial%20photography%2C%20no%20text&width=600&height=800&seq=cover-under-eaves&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20wide%20shot%20of%20a%20narrow%20japanese%20residential%20street%20at%20dusk%2C%20old%20wooden%20houses%20with%20warm%20amber%20window%20lights%2C%20deep%20navy%20evening%20sky%2C%20utility%20poles%20and%20soft%20mist%2C%20film%20grain%2C%20nostalgic%20quiet%20atmosphere%2C%20no%20text&width=1600&height=900&seq=backdrop-under-eaves&orientation=landscape",
    tagline: "家不是港湾，是我们共同忍耐的地方",
    summary:
      "四代人住在同一栋老屋里，十集故事几乎没有离开过那间十二叠的客厅。所有的社会压力，都被这扇门逼进屋檐之下。",
    synopsis: [
      "东京郊外的一栋老屋，住着祖母、父母、儿子与刚出生的孙女。长子夫妇因为房贷搬回老家，三代人的作息、口味与价值观在一间客厅里互相摩擦。",
      "全剧九成场景发生在同一栋房子，走廊的宽度、楼梯的吱呀声、厨房的抽油烟机，构成了人物关系的物理地图。没有反派，只有被生活压到极限的普通人。",
      "老屋最终被卖掉，一家人各自搬进新的公寓。这不是失败，而是一种诚实的处理：有些关系不需要被修复，只需要被允许改变形态。",
    ],
    roles: [
      {
        name: "祖母 · 佐和",
        actor: "小林千春",
        description:
          "八十二岁，一生操持家务。她的控制欲来自她被控制的一生，最怕的不是死亡，而是被当作无用的人。",
      },
      {
        name: "儿媳 · 美咲",
        actor: "吉冈澄",
        description:
          "三十八岁，重返职场的母亲。她的沉默不是顺从，而是把所有力气都用来维持表面的平静。",
      },
      {
        name: "长子 · 启太",
        actor: "森川启",
        description:
          "典型的和事佬，从小被教育「不要惹事」。他最大的伦理困境，是既想做个好儿子，也想做个好丈夫。",
      },
    ],
    reviews: [
      {
        title: "一部关于「不离开」的家庭剧",
        author: "何嘉言",
        date: "2024-09-24",
        excerpt:
          "它几乎不拍外面的世界，却把整个社会的压力都逼进了那间十二叠的客厅。",
        content: [
          "第八集的餐桌长镜头值得反复观看：一家人吃饭，没有人说话，只有筷子的声音。",
          "结局没有和解的拥抱，只有各自搬进新公寓的日常。这或许才是真正的成熟。",
        ],
      },
    ],
    featured: true,
  },
  {
    id: "silent-tide",
    title: "静默之潮",
    originalTitle: "Silent Tide",
    kind: "movie",
    year: 2023,
    region: "中国大陆",
    genres: ["剧情", "家庭", "伦理"],
    rating: 8.7,
    votes: 35120,
    views: 288000,
    director: "陈书言",
    cast: ["周蔓", "李崇", "沈诗雨", "赵听涛"],
    duration: "116 分钟",
    cover:
      "https://readdy.ai/api/search-image?query=moody%20cinematic%20film%20poster%20artwork%20of%20a%20lone%20woman%20in%20a%20pale%20linen%20dress%20standing%20at%20a%20rain%20streaked%20window%20of%20an%20old%20seaside%20house%2C%20deep%20navy%20shadows%20with%20faint%20warm%20amber%20lamplight%2C%20soft%20film%20grain%2C%20minimal%20negative%20space%2C%20quiet%20melancholy%2C%20editorial%20photography%2C%20no%20text&width=600&height=800&seq=cover-silent-tide&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20wide%20shot%20of%20a%20grey%20stormy%20sea%20behind%20an%20old%20wooden%20pier%20at%20dusk%2C%20navy%20blue%20water%20and%20muted%20amber%20horizon%20light%2C%20drifting%20mist%2C%20lonely%20silhouette%20of%20a%20woman%20in%20the%20distance%2C%20atmospheric%20film%20still%20look%2C%20soft%20grain%2C%20no%20text&width=1600&height=900&seq=backdrop-silent-tide&orientation=landscape",
    tagline: "所有人都知道，所以所有人都沉默",
    summary:
      "海边小镇，一桩被集体默认的旧事。一个家庭在长达十五年的沉默里慢慢腐烂，直到最小的女儿决定离开。",
    synopsis: [
      "故事发生在东南沿海一个以养殖为生的小镇。十五年前的一场意外被父亲用一个谎言掩盖，而这个谎言逐渐成了整个镇子的共识。",
      "影片开场有整整三分钟没有台词，只有潮水、风声和远处渔船的引擎。这种耐心奠定了全片的基调：它不解释，它让你待在那里。",
      "导演大量使用门框与窗框构图，让人物总被切割。女儿最终选择离开小镇的那场戏，她第一次走出画框，走向镜头外的海。",
    ],
    roles: [
      {
        name: "父亲 · 陈立庄",
        actor: "李崇",
        description:
          "养殖场老板，一辈子讲体面。他相信只要不提，事情就不存在，最终被自己的沉默压垮。",
      },
      {
        name: "女儿 · 陈晚",
        actor: "沈诗雨",
        description:
          "十七岁，唯一不肯配合谎言的人。她的叛逆不是青春期的冲动，而是一种本能的道德直觉。",
      },
      {
        name: "母亲 · 阿芸",
        actor: "周蔓",
        description:
          "在丈夫与孩子之间维持平衡的女人。她知道一切，却把知情变成了另一种照顾。",
      },
    ],
    reviews: [
      {
        title: "沉默是一种共谋",
        author: "林知远",
        date: "2024-06-30",
        excerpt:
          "它没有给出惩罚，也没有给出原谅，只是让沉默的重量被完整地看见。",
        content: [
          "影片的核心冲突并不激烈，甚至可以说是「什么都没发生」，但张力从未松懈。",
          "伦理题材最难的是不说教，这部电影做到了。",
        ],
      },
    ],
    featured: true,
  },
  {
    id: "white-dew",
    title: "白露为霜",
    originalTitle: "Frost at White Dew",
    kind: "movie",
    year: 2022,
    region: "中国台湾",
    genres: ["剧情", "伦理", "女性"],
    rating: 8.5,
    votes: 29480,
    views: 214000,
    director: "林知遥",
    cast: ["许安琪", "温以宁", "陈叙", "李蓉"],
    duration: "104 分钟",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20poster%20art%20of%20a%20woman%20in%20a%20white%20blouse%20standing%20behind%20a%20sheer%20curtain%20in%20a%20warm%20lit%20apartment%2C%20half%20of%20her%20face%20in%20shadow%2C%20muted%20navy%20and%20cream%20palette%20with%20amber%20lamp%20glow%2C%20film%20grain%2C%20quiet%20tension%2C%20minimal%20editorial%20photography%2C%20no%20text&width=600&height=800&seq=cover-white-dew&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20wide%20shot%20of%20a%20dim%20taipei%20apartment%20living%20room%20with%20heavy%20curtains%2C%20a%20single%20warm%20amber%20floor%20lamp%2C%20a%20half%20finished%20cup%20of%20tea%20on%20a%20low%20table%2C%20navy%20shadows%2C%20soft%20film%20grain%2C%20restrained%20melancholy%2C%20no%20text&width=1600&height=900&seq=backdrop-white-dew&orientation=landscape",
    tagline: "没有一巴掌，也没有一句脏话",
    summary:
      "一段外人看来体面完美的婚姻，在温和的语气与无微不至的关心里，慢慢抽走一个女人的呼吸。",
    synopsis: [
      "宜臻嫁给了一位人人称羡的丈夫。他体贴、体面、事业有成，从不发火，只是会在她出门前轻声问一句「你确定要穿这件吗」。",
      "家里的灯永远是暖黄的，但窗外的自然光被厚厚的窗帘挡在外面。她的脸始终处在一半阴影里，直到某天她第一次独自把窗帘拉开。",
      "影片以母女两代人的对照，把议题从个人扩展到结构：母亲那代人把忍耐当成美德，女儿这代人则要面对「你明明可以走」的新压力。",
    ],
    roles: [
      {
        name: "宜臻",
        actor: "许安琪",
        description:
          "四十岁的中学美术教师，擅长画静物，却不擅长表达自己的需要。她的反抗从一盆兰花开始。",
      },
      {
        name: "丈夫 · 陈叙",
        actor: "陈叙",
        description:
          "律师，完美的倾听者。他的控制从不高声，而是通过替对方做完所有决定来完成。",
      },
      {
        name: "母亲 · 李蓉",
        actor: "李蓉",
        description:
          "把忍耐当作美德的上一代女性。她既心疼女儿，又真心相信「日子就是这样过的」。",
      },
    ],
    reviews: [
      {
        title: "亲密关系里的隐形暴力",
        author: "苏禾",
        date: "2024-05-12",
        excerpt:
          "这部电影用最温和的语气，拍出了最令人窒息的亲密关系。",
        content: [
          "导演用光线完成了一次隐喻：家里的灯是暖的，但自然光被挡在外面。",
          "结尾没有戏剧性的反抗，只有一次安静的搬家。这个克制的结尾，比任何控诉都更有力。",
        ],
      },
    ],
    featured: true,
  },
  {
    id: "fourth-wall",
    title: "第四面墙",
    originalTitle: "The Fourth Wall",
    kind: "movie",
    year: 2021,
    region: "中国香港",
    genres: ["剧情", "悬疑", "伦理"],
    rating: 8.3,
    votes: 26870,
    views: 198000,
    director: "何家骏",
    cast: ["钟景行", "邓予安", "梁静文", "何乐"],
    duration: "112 分钟",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20poster%20art%20of%20an%20empty%20old%20apartment%20living%20room%20with%20a%20single%20spotlight%20on%20a%20wooden%20chair%20facing%20a%20cracked%20mirror%2C%20deep%20navy%20tones%20with%20warm%20amber%20highlight%2C%20heavy%20atmosphere%2C%20film%20grain%2C%20minimal%20composition%2C%20editorial%20photography%2C%20no%20text&width=600&height=800&seq=cover-fourth-wall&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20wide%20shot%20of%20a%20cramped%20hong%20kong%20apartment%20with%20a%20long%20dining%20table%20and%20four%20chairs%2C%20one%20bare%20bulb%20above%2C%20navy%20shadows%20and%20amber%20light%2C%20worn%20walls%2C%20theatrical%20framing%2C%20film%20grain%2C%20no%20text&width=1600&height=900&seq=backdrop-fourth-wall&orientation=landscape",
    tagline: "这个家，是一个舞台",
    summary:
      "过气话剧演员把家变成舞台，给每个家人分配了角色。一场为期三天的家庭聚会，变成了一场没有旁白的审判。",
    synopsis: [
      "父亲曾是一位小有名气的话剧演员，退休后他把全部的控制欲都放在了家里。晚餐要按剧本进行，连沉默都有规定的时长。",
      "摄影机几乎不离开公寓，镜头高度始终保持在人的视线水平，观众像是坐在客厅的第五把椅子上。",
      "影片中段有一场长达十四分钟的争吵，没有任何剪辑。情绪在长镜头里层层堆叠，直到某一刻突然断裂。",
    ],
    roles: [
      {
        name: "父亲 · 高维",
        actor: "钟景行",
        description:
          "过气演员，一生都在表演。他最深层的恐惧不是被讨厌，而是被忘记。",
      },
      {
        name: "女儿 · 高澄",
        actor: "梁静文",
        description:
          "刚从英国回来的建筑师，习惯用图纸思考关系。她是唯一敢走出舞台的人。",
      },
      {
        name: "母亲 · 阿珍",
        actor: "邓予安",
        description:
          "沉默的旁观者，也是这场家庭戏剧最早的观众。她用三十年学会分辨哪句是真话。",
      },
    ],
    reviews: [
      {
        title: "当家庭成为一间审讯室",
        author: "陈默",
        date: "2024-03-18",
        excerpt:
          "四个人物，一块不存在的第四面墙，观众被迫成为这场家庭审判的旁听者。",
        content: [
          "摄影机几乎不离开公寓，这种设计让偷窥感与共犯感同时成立。",
          "最后一幕，父亲对着镜子念台词，镜子里却没有观众。",
        ],
      },
    ],
  },
  {
    id: "mute-witness",
    title: "失语的证人",
    originalTitle: "The Silent Witness",
    kind: "movie",
    year: 2020,
    region: "韩国",
    genres: ["剧情", "犯罪", "伦理"],
    rating: 8.0,
    votes: 31240,
    views: 176000,
    director: "朴正元",
    cast: ["金泰河", "尹素拉", "朴敏载", "崔恩"],
    duration: "121 分钟",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20poster%20art%20of%20a%20silent%20man%20seen%20from%20behind%20in%20a%20dim%20courtroom%20corridor%2C%20desaturated%20navy%20grey%20walls%2C%20a%20single%20warm%20amber%20light%20above%20a%20wooden%20door%2C%20film%20grain%2C%20oppressive%20stillness%2C%20minimal%20editorial%20photography%2C%20no%20text&width=600&height=800&seq=cover-mute-witness&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20wide%20shot%20of%20an%20empty%20korean%20courtroom%20at%20dusk%2C%20rows%20of%20wooden%20benches%2C%20cold%20navy%20light%20through%20tall%20windows%2C%20warm%20amber%20lamp%20on%20the%20judge%20desk%2C%20soft%20film%20grain%2C%20solemn%20quiet%20atmosphere%2C%20no%20text&width=1600&height=900&seq=backdrop-mute-witness&orientation=landscape",
    tagline: "沉默的人，有没有罪",
    summary:
      "一个聋哑目击者，一桩找不到证据的案件。当证词需要被翻译，真相还能剩下多少重量？",
    synopsis: [
      "一场夜间事故，唯一的目击者是一位聋哑的便利店店员。他看见了凶手的脸，却在法庭上被反复质疑「你是否真的理解你看到的东西」。",
      "影片最有力量的部分，是对「证词」这件事的拆解。手语翻译在法庭上并不是中立的，她的措辞、语序、甚至表情，都会改变证词的重量。",
      "主人公并非完美受害者，他曾因为害怕而选择沉默。影片拒绝把他塑造成英雄，只把他还原成一个在恐惧与良知之间摇摆的普通人。",
    ],
    roles: [
      {
        name: "李正秀",
        actor: "金泰河",
        description:
          "便利店夜班店员，先天失聪。他最大的愿望不是正义，而是不再被人当成看不见的人。",
      },
      {
        name: "手语翻译 · 尹智恩",
        actor: "尹素拉",
        description:
          "法庭指定翻译，专业而克制。她在一次次的转述中，逐渐意识到自己也在改写别人的命运。",
      },
      {
        name: "检察官 · 朴敏载",
        actor: "朴敏载",
        description:
          "急于定案的年轻检察官。他不是恶人，只是把效率误当成了正义。",
      },
    ],
    reviews: [
      {
        title: "沉默的人有没有罪",
        author: "高远",
        date: "2024-02-05",
        excerpt:
          "韩国导演朴正元用近乎纪录片的冷静，追问目击与作证之间的伦理距离。",
        content: [
          "导演刻意保留了翻译过程的延迟感，让观众体会到沟通本身的成本。",
          "结尾字幕交代了案件的真实结局，很冷静，却让前面两小时的情绪有了落点。",
        ],
      },
    ],
  },
  {
    id: "north-of-return",
    title: "归途以北",
    originalTitle: "North of the Return",
    kind: "movie",
    year: 2019,
    region: "中国大陆",
    genres: ["剧情", "家庭", "公路"],
    rating: 8.1,
    votes: 24310,
    views: 165000,
    director: "沈亦然",
    cast: ["宋知远", "周予", "高维安", "刘冉"],
    duration: "108 分钟",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20poster%20art%20of%20a%20snowy%20northern%20railway%20platform%20at%20blue%20hour%2C%20a%20father%20and%20a%20teenage%20boy%20standing%20apart%20with%20a%20suitcase%20between%20them%2C%20deep%20navy%20sky%20and%20warm%20amber%20station%20lamps%2C%20soft%20grain%2C%20restrained%20composition%2C%20editorial%20photography%2C%20no%20text&width=600&height=800&seq=cover-north-of-return&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20wide%20shot%20of%20an%20empty%20snow%20covered%20railway%20track%20cutting%20through%20a%20frozen%20northern%20town%20at%20dusk%2C%20deep%20navy%20sky%2C%20warm%20amber%20lamps%20along%20the%20platform%2C%20falling%20snow%2C%20soft%20film%20grain%2C%20lonely%20cinematic%20mood%2C%20no%20text&width=1600&height=900&seq=backdrop-north-of-return&orientation=landscape",
    tagline: "有些父亲，只会用沉默表达爱",
    summary:
      "一对十年未见的父子，为了处理一场遗产纠纷，被迫一起坐上北上的绿皮火车。",
    synopsis: [
      "父亲在北方小城去世，留下了一间旧厂房和一笔说不清的债务。多年未归的儿子必须回去签字，而厂房的另一位权利人，是他十年没有联系的父亲的老友。",
      "整部电影大部分时间发生在火车与候车室。父子二人的对话极少，更多时候是各自看着窗外的雪。导演用大量的静默，拍出了中国式父子关系里那种笨拙的关心。",
      "影片最后，儿子在厂房里找到了父亲留下的账本，上面记着每一笔借款与每一个还款日期。他第一次意识到，这个男人一生都在努力不欠别人什么。",
    ],
    roles: [
      {
        name: "儿子 · 宋知远",
        actor: "宋知远",
        description:
          "在南方做建筑设计的三十岁男人。他离开家乡的理由很简单：不想成为父亲那样的人。",
      },
      {
        name: "父亲 · 老宋（回忆）",
        actor: "高维安",
        description:
          "退休工人，一生要强。他不懂得表达歉意，只能用账本记录自己的清白。",
      },
      {
        name: "厂长老周",
        actor: "周予",
        description:
          "父亲的老友，也是这场纠纷的另一方。他守着一间空厂房，像守着一个时代的体面。",
      },
    ],
    reviews: [
      {
        title: "火车上的中国式父子",
        author: "顾清",
        date: "2024-01-16",
        excerpt:
          "它没有激烈的冲突，只有两个男人在车厢连接处抽烟时，那几句没头没尾的话。",
        content: [
          "导演用大量的静默，拍出了中国式父子关系里那种笨拙的关心。",
          "账本这个道具用得极好，它既是证据，也是遗书。",
        ],
      },
    ],
  },
  {
    id: "rain-changan",
    title: "雨落长安",
    originalTitle: "Rain Over Chang'an",
    kind: "movie",
    year: 2018,
    region: "中国大陆",
    genres: ["剧情", "历史", "伦理"],
    rating: 7.9,
    votes: 19860,
    views: 142000,
    director: "顾行舟",
    cast: ["沈砚", "苏莞", "李承泽", "郑绾"],
    duration: "132 分钟",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20poster%20art%20of%20a%20rain%20soaked%20tang%20dynasty%20street%20at%20night%2C%20an%20oil%20paper%20umbrella%20and%20a%20stone%20archway%2C%20deep%20navy%20sky%20with%20warm%20amber%20lantern%20reflections%20on%20wet%20stone%2C%20film%20grain%2C%20poetic%20minimal%20composition%2C%20editorial%20photography%2C%20no%20text&width=600&height=800&seq=cover-rain-changan&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20wide%20shot%20of%20an%20ancient%20chinese%20city%20wall%20and%20lantern%20lit%20street%20during%20heavy%20rain%20at%20night%2C%20deep%20navy%20sky%2C%20warm%20amber%20lantern%20glow%20reflected%20in%20puddles%2C%20distant%20figure%20with%20umbrella%2C%20soft%20film%20grain%2C%20no%20text&width=1600&height=900&seq=backdrop-rain-changan&orientation=landscape",
    tagline: "一个选择，改写三代人的命运",
    summary:
      "唐末长安，一名小吏在动荡中为了保护家人而做下一个决定，这个决定让三代人背负了同一份愧疚。",
    synopsis: [
      "故事从一场夜雨开始。长安城破前夕，掌管户籍的小吏李元度私改了一份文书，把一位故人之子从流放名单里划去。",
      "这个善意的举动，在二十年后变成了一桩血案。影片以三段时间线交错推进，让观众亲眼看见一个道德选择如何在不同的人身上长出完全不同的果实。",
      "导演用大量雨景与灯笼光营造出末世的氛围。全片没有绝对的善恶，只有被时代推着走的普通人。",
    ],
    roles: [
      {
        name: "李元度",
        actor: "沈砚",
        description:
          "长安小吏，谨慎了一辈子，只做过一次冒险的决定。此后余生都在为这一次冒险付账。",
      },
      {
        name: "苏莞",
        actor: "苏莞",
        description:
          "李元度的妻子，最早察觉到丈夫秘密的人。她选择一起隐瞒，也一起承受。",
      },
      {
        name: "少年 · 李承泽",
        actor: "李承泽",
        description:
          "被救下的孩子，长大后成为执法者。他追查的旧案，正是自己的救命之恩。",
      },
    ],
    reviews: [
      {
        title: "善意的代价",
        author: "周慕之",
        date: "2023-12-02",
        excerpt:
          "它讲的是伦理选择的历史重量：一个人为了爱做的好事，如何变成另一个人的灾难。",
        content: [
          "影片用三段时间线交错推进，让同一个选择在不同的人身上长出不同的果实。",
          "全片没有绝对的善恶，只有被时代推着走的普通人。",
        ],
      },
    ],
  },
  {
    id: "seventh-spring",
    title: "第七个春天",
    originalTitle: "The Seventh Spring",
    kind: "series",
    year: 2024,
    region: "中国大陆",
    genres: ["剧情", "伦理", "年代"],
    rating: 8.2,
    votes: 42180,
    views: 296000,
    director: "温向阳",
    cast: ["沈知夏", "陆行舟", "许棠", "方岐"],
    episodes: 24,
    duration: "单集 42 分钟",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20poster%20art%20of%20a%20young%20woman%20standing%20in%20a%20blooming%20orchard%20under%20pale%20spring%20light%2C%20deep%20navy%20and%20warm%20amber%20color%20grading%2C%20wind%20blown%20petals%2C%20distant%20figure%20of%20a%20man%2C%20film%20grain%2C%20restrained%20poetic%20composition%2C%20editorial%20photography%2C%20no%20text&width=600&height=800&seq=cover-seventh-spring&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20wide%20shot%20of%20a%20rural%20chinese%20orchard%20in%20early%20spring%20with%20white%20blossoms%2C%20an%20old%20brick%20farmhouse%20in%20the%20distance%2C%20soft%20navy%20morning%20mist%20and%20warm%20amber%20sunrise%2C%20film%20grain%2C%20nostalgic%20quiet%20mood%2C%20no%20text&width=1600&height=900&seq=backdrop-seventh-spring&orientation=landscape",
    tagline: "一个村庄，七个春天，两代人的秘密",
    summary:
      "南方村庄的七年时间，两代女性在土地、婚姻与承诺之间反复权衡。一个关于「留下来」与「走出去」的长篇故事。",
    synopsis: [
      "故事从上世纪九十年代末开始，村小教师沈知夏在第七个春天做出了一个决定：留下来，接手无人愿意耕种的那片果园。",
      "剧集以年为单位推进，每年一个春天。土地流转、外出务工、婚姻选择，每一个宏大的时代议题都落在一个具体的家庭里。",
      "母亲那一代把牺牲当作命运，女儿这一代则要在自由与责任之间自己找答案。剧集没有给出标准答案，只给出了七次选择的完整过程。",
    ],
    roles: [
      {
        name: "沈知夏",
        actor: "沈知夏",
        description:
          "村小教师，后来成为果园的承包者。她的一生都在回答一个问题：留下来是不是一种认输。",
      },
      {
        name: "母亲 · 许棠",
        actor: "许棠",
        description:
          "上一代的留守女性，把一生的委屈都酿成了沉默。她最大的心愿是女儿不要重复自己。",
      },
      {
        name: "陆行舟",
        actor: "陆行舟",
        description:
          "从城里来的农业技术员，也是知夏唯一平等对话的对象。他的出现让「离开」第一次成为一种选择而非背叛。",
      },
    ],
    reviews: [
      {
        title: "七次选择，一种人生",
        author: "沈砚秋",
        date: "2024-09-02",
        excerpt:
          "它把宏大的时代议题，全部落在了一日三餐和一片果园上。这种耐心，在当下的剧集里非常少见。",
        content: [
          "剧集以年为单位推进，每年一个春天，结构清晰却不机械。",
          "母亲与女儿的对照，让「牺牲」这个沉重的词第一次被真正讨论。",
        ],
      },
    ],
  },
  {
    id: "stranger-in-mirror",
    title: "镜中的陌生人",
    originalTitle: "Stranger in the Mirror",
    kind: "series",
    year: 2021,
    region: "英国",
    genres: ["心理", "悬疑", "伦理"],
    rating: 8.4,
    votes: 28640,
    views: 188000,
    director: "Ellen Hart",
    cast: ["Clara Reid", "Tom Vance", "Nadia Cole", "Ian Frost"],
    episodes: 8,
    duration: "单集 52 分钟",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20poster%20art%20of%20a%20psychologist%20sitting%20across%20a%20man%20in%20a%20dark%20consulting%20room%2C%20a%20large%20mirror%20between%20them%20reflecting%20neither%20face%20clearly%2C%20deep%20navy%20green%20shadows%20and%20warm%20amber%20lamp%2C%20film%20grain%2C%20psychological%20tension%2C%20editorial%20photography%2C%20no%20text&width=600&height=800&seq=cover-stranger-in-mirror&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20wide%20shot%20of%20a%20london%20therapy%20office%20at%20night%20with%20two%20empty%20armchairs%20facing%20each%20other%2C%20floor%20to%20ceiling%20windows%20with%20rain%2C%20deep%20navy%20green%20tones%20and%20a%20warm%20amber%20desk%20lamp%2C%20soft%20film%20grain%20no%20text&width=1600&height=900&seq=backdrop-stranger-in-mirror&orientation=landscape",
    tagline: "治疗室里，没有人说出全部真话",
    summary:
      "一名心理治疗师接手了一位失忆的来访者，八次会谈之后，她开始怀疑需要被治疗的人是自己。",
    synopsis: [
      "八集剧集，八次会谈，几乎全部发生在同一间治疗室。来访者声称自己不记得案发当晚的任何细节，却在每次会谈中给出略有出入的版本。",
      "治疗师的专业训练要求她保持中立，但来访者的叙述逐渐与她自己的一段旧事重叠。剧集用大量镜像构图，让两个人的身份在观众眼前慢慢模糊。",
      "第八集的反转并不依赖巧合，而是建立在前面七集所有细微的措辞与停顿之上。伦理边界在这里不是抽象概念，而是每一次「我该不该继续问下去」的具体选择。",
    ],
    roles: [
      {
        name: "Dr. Ruth Alden",
        actor: "Clara Reid",
        description:
          "资深心理治疗师，写了一本关于创伤记忆的书。她最擅长帮别人面对真相，唯独回避自己的。",
      },
      {
        name: "Evan",
        actor: "Tom Vance",
        description:
          "失忆的来访者，礼貌、配合、逻辑清晰。他的每一次遗忘都精准地指向某个关键细节。",
      },
      {
        name: "督导 · Nadia",
        actor: "Nadia Cole",
        description:
          "Ruth 的督导与旧友，全剧唯一能让她停下来的人。她代表着职业伦理那条不能越过的线。",
      },
    ],
    reviews: [
      {
        title: "治疗室里的伦理边界",
        author: "陈默",
        date: "2024-04-09",
        excerpt:
          "八次会谈，八次试探。它真正让人不安的地方，是你会发现自己一直在替主角合理化越界。",
        content: [
          "镜像构图贯穿全剧，两个人的身份在观众眼前慢慢模糊。",
          "反转建立在前七集所有细微的措辞与停顿之上，非常扎实。",
        ],
      },
    ],
  },
];